// extracted by mini-css-extract-plugin
export var boostCrown = "Product_boostCrown__XXRtw";
export var closeButton = "Product_closeButton__58pc9";
export var closeIcon = "Product_closeIcon__TjuhI fontawesome_min_far__yZwJE fontawesome_min_fa-times__LbGn0";
export var container = "Product_container__-LWxM";
export var faLockAlt = "Product_faLockAlt__+44Pk fontawesome_min_fa-lock-alt__xoCuD";
export var faLockOpenAlt = "Product_faLockOpenAlt__-xNlM fontawesome_min_fa-lock-open-alt__sLoBF";
export var faTimes = "Product_faTimes__IXi+R fontawesome_min_fa-times__LbGn0";
export var fal = "Product_fal__6jUfP fa-light_min_fal__ABekM fontawesome_min_fal__-+-vD";
export var far = "Product_far__HnhDq fontawesome_min_far__yZwJE";
export var imageAnchor = "Product_imageAnchor__QEJ0p";
export var imageContainer = "Product_imageContainer__LcNLF";
export var info = "Product_info__LrbH2";
export var infoContainer = "Product_infoContainer__czjRY";
export var linkContainer = "Product_linkContainer__Tpw11";
export var lockedIcon = "Product_lockedIcon__x8BbZ fontawesome_min_fal__-+-vD fontawesome_min_fa-lock-alt__xoCuD";
export var modalContent = "Product_modalContent__xZr+T";
export var modalLink = "Product_modalLink__1VYPE";
export var name = "Product_name__VIlE-";
export var price = "Product_price__8bEZM";
export var question = "Product_question__HQ1PS";
export var replacementTag = "Product_replacementTag__kT+yT";
export var selectText = "Product_selectText__64A3+";
export var thumbnail = "Product_thumbnail__XnAox";
export var unlockedIcon = "Product_unlockedIcon__13YmG fontawesome_min_fal__-+-vD fontawesome_min_fa-lock-open-alt__sLoBF";